/** How long each checklist item shows the spinner before the checkmark. */
export const PROCESSING_ITEM_DURATION_MS = 2000;

/** Brief pause after the last check before switching to the results step. */
export const PROCESSING_COMPLETE_HOLD_MS = 400;

export const PROCESSING_ESTIMATE_AMOUNT = 750;

export const PROCESSING_CHECKLIST = [
  'Matching your answers',
  'Checking eligibility requirements',
  'Calculating your estimate',
] as const;
